/* eslint-disable prefer-promise-reject-errors */
import _ from 'lodash';
import defaultAxios from 'axios';
import vm from './vm';
import axios from './axios-ins';
import vmAxios from './vm-axios-ins';
import {
  authErrorCode,
  getUserId, getUserSlug, isAcceptedUser, logOutMeta, removeCreds, setLogoutUrl, setUserId, setUserToken,
} from './utils';
import { colors } from '../constants';

export const getAuthMeta = () => axios.get(`${getUserSlug()}/getAuthenticationMeta`, {
  params: {
    redirectUrl: `${window.location.origin}/auth-callback`,
  },
}).then(({ data }) => data);

export const exchangeToken = (token) => axios
  .post(`${getUserSlug()}/exchangeToken`, {
    token,
    redirectUrl: `${window.location.origin}/auth-callback`,
  }).then((response) => {
    const { data, headers: { 'x-csrf-token': userToken } } = response;
    if (!isAcceptedUser(data.profile)) return Promise.reject({ statusCode: 401, code: authErrorCode });
    setUserId(data.userId);
    setUserToken(userToken);
    return { ...data.profile, id: data.userId };
  });

export const getUser = () => axios.get(`${getUserSlug()}/${getUserId()}`)
  .then(({ data }) => {
    if (!isAcceptedUser(data)) return Promise.reject({ statusCode: 401, code: authErrorCode });
    return data;
  });

export const startLogin = () => getAuthMeta().then(({ url, logoutUrl }) => {
  setLogoutUrl(logoutUrl);
  window.location.href = url;
  return new Promise(() => { });
});
export const logOut = () => axios.post(logOutMeta.url(), logOutMeta.data()).then(removeCreds);

export const getReports = () => axios.post('/tasks/runTasks', {
  taskIds: [
    'getDashboardStatistics',
  ],
}).then((res) => res.data);

export const executeInVM = (code, sandbox) => {
  const ctx = vm.createContext(sandbox);
  return vm.runInContext(code, ctx);
};

const getReportData = (filter, cancelToken) => axios.get('/Statistics/getData', { params: { filter }, cancelToken }).then((res) => res.data);

export const getChartData = ({
  reportSlug, queryData, formData, listsCache,
}) => {
  const source = defaultAxios.CancelToken.source();
  const cancelFn = () => source.cancel();
  const promise = getReportData({
    reportSlugs: [reportSlug], reportFilter: { where: queryData },
  }, source.token)
    .then(([data]) => {
      if (data.mapping === 'result') return { labels: [], datasets: [] }; // remove later
      return executeInVM(data.mapping, {
        _,
        result: data[reportSlug],
        COLORS: colors,
        SERVICE_LABELS: {},
        axios: vmAxios,
        middlewareURL: window.env.REACT_APP_BACKEND_URL,
        formData,
        formSelectFieldsOptions: listsCache,
      });
    });
  promise.cancel = cancelFn;
  return promise;
};
